import { HeadDotsHorizontalIcon } from './HeadDotsHorizontalIcon';

/**
 * author: Michael Irigoyen
 * id DE191219-96D0-4189-8BE1-8F24A5E3E492
 * name head-dots-horizontal
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-dots-horizontal.svg
 * tags
 */
export const HeadThinkingIcon = HeadDotsHorizontalIcon;
export default HeadThinkingIcon